import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface HoverTriggerProps {
  component: ReactNode
  hoverComponent: ReactNode
}

const NonHovered = styled.div``
const Hovered = styled.div``

const HoverContainer = styled.div`
  &:not(:hover) {
    ${Hovered} {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
  }

  &:hover {
    ${NonHovered} {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
  }
`

/**
 * HoverTrigger
 *
 * Component that allows swapping content when
 * hovering over the element in the browser
 *
 * Pure CSS because React (and other frameworks)
 * have problems when moving the mouse too fast
 * and some out/leaving events do not fire.
 * Do not change this approach, please.
 */
export const HoverTrigger = (props: HoverTriggerProps) => {
  const { component, hoverComponent } = props

  return (
    <HoverContainer>
      <NonHovered>{component}</NonHovered>
      <Hovered>{hoverComponent}</Hovered>
    </HoverContainer>
  )
}
